import { render, staticRenderFns } from "./constructionRelactionTaskImpr.vue?vue&type=template&id=3f7c33a8"
import script from "./constructionRelactionTaskImpr.vue?vue&type=script&lang=js"
export * from "./constructionRelactionTaskImpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f7c33a8')) {
      api.createRecord('3f7c33a8', component.options)
    } else {
      api.reload('3f7c33a8', component.options)
    }
    module.hot.accept("./constructionRelactionTaskImpr.vue?vue&type=template&id=3f7c33a8", function () {
      api.rerender('3f7c33a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/scm/constructionRelactionTaskImpr.vue"
export default component.exports